import React, { useState, useEffect } from "react";
import SearchBar from "../SearchBar";
import PokemonRandom from "../PokemonRandom";
import loader from "../../assets/loader-ramolos.gif";

function Home() {
  /****        Déclaration des variables      ****/
  const [pokemonRandom, setRandomPokemon] = useState();
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  /* initialise un numéro de pokemon aléatoire compris en 1 et 898*/
  const pokemonIdMini = 1;
  const pokemonIdMaxi = 898;

  const getRandomIntInclusive = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  // const key = process.env.REACT_APP_FAKE_API_KEY

  // fonction pour toutes les requetes API
  const sendRequest = (endRequest, fonction) => {
    const apiPath =  `${process.env.REACT_APP_API_PATH}`;
    let requestURL = apiPath + endRequest;
    // console.log(key)
    setIsLoading(true);
    fetch(requestURL)
      .then((res) => {
        if (res.status === 500) {
          return setError("Pas de pokemon trouvé");
        } else {
          setIsLoading(false);
          return res.json();
        }
      })

      .then((value) => {
        if (value === 0) {
          return setError("error404");
        } else {
          return fonction(value);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setError("error500");
      });
  };

  /* useEffect au chargement */
  useEffect(() => {
    const idRandom = getRandomIntInclusive(pokemonIdMini, pokemonIdMaxi);
    sendRequest(idRandom, setRandomPokemon);
  }, []);

  useEffect(() => {
    sendRequest("", setData);
  }, []);


  return (
    <div className="h-screen bg-homeImage bg-no-repeat w-auto bg-position-[center_top_-2rem]">
      <div className="pt-52">
        <SearchBar allPokemon={data} />
        {isLoading ? (
          <div className="text-center">
            <img src={loader} alt="" className="block m-auto" />
            <h2>CHARGEMENT</h2>
          </div>
        ) : (
          <div className=" pt-40">
            <PokemonRandom pokemon={pokemonRandom} />
          </div>
        )}
      </div>
      {error && <div className="error">{error}</div>}
    </div>
  );
}
export default Home;
